import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from "@reach/router"
import _ from "lodash"
import ReportsStandalone from 'components/folder/reports/reports-standalone'
import ListboxInput from "components/inputs/listbox"
import { ButtonWithPress_s, Label_s } from 'styles/app-styles'
import { local } from "data/lib/local-json"
import propertyService from "data/property"
import propertyReportService from "data/reports-property"
import notificationService from "data/notification"

export const PropertyAEExport: FC<RouteComponentProps> = (props) => {
  const [mode, setMode] = useState<"export_file" | "comparison_template">("export_file")



  const submit = () => {
    const propId = local("property")
    const currentProp = propertyService.get(propId)
    const uncalculated = !['Calculated', 'Calculated with Warnings'].includes(currentProp?.calcdetail?.status)

    if (mode === "comparison_template" && uncalculated) {
      notificationService.notify({
        type: "danger",
        message: "The current property must be calculated when templates are selected",
        dismiss: 3000
      })
    } else {
      const payload = {
        report: mode === "comparison_template" ?  "_comparison" : "_test_export" ,
        propertyid: propId,
        params: {}
      }
      propertyReportService.propertyReport(payload)
      notificationService.notify({
        type: "info",
        message: "AE Export Initiated",
        dismiss: 3000
      })
    }
  }

  return (
    <div style={{ margin: "10px" }}>
      <label style={{ color: "red", marginBottom: "8px", display: "block" }}>This feature is currently in beta.  Please contact Support for more information.</label>
      <div style={{ marginBottom: "10px" }}>
        <ButtonWithPress_s primary onClick={submit}>
          Export
        </ButtonWithPress_s>
      </div>
      <div>
        <label>
          <input
            type="radio"
            onClick={(e) => setMode("export_file")}
            checked={mode === "export_file"} />
          AE Export File
        </label>
        <label>
          <input
            type="radio"
            onClick={(e) => setMode("comparison_template")}
            checked={mode === "comparison_template"} />
          Comparison Template (requires calculation)
        </label>
      </div>
    </div>
  )
}

export default PropertyAEExport
